import React from "react";

export default function RadioButtonV2({
  onChange,
  label = "Select me!",
  className,
  checked,
  name,
  disabled,
  value,
  type = "radio",
  labelSize = "text-sm",
}) {
  const handleRadioChange = (event) => {
    onChange(event);
  };

  return (
    <div className="p-1 items-center">
      <label className="flex items-center space-x-2">
        <input
          name={name}
          type={type}
          value={value}
          className={`h-4 w-4 text-indigo-600 focus:ring focus:ring-indigo-200 ${className}`}
          checked={checked}
          disabled={disabled}
          onChange={handleRadioChange}
        />
        <span className={`${labelSize} text-gray-700 font-normal items-center`}>
          {label}
        </span>
      </label>
    </div>
  );
}
